import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-payment-redirect',
  templateUrl: './payment-redirect.component.html',
  styleUrls: ['./payment-redirect.component.scss'],
})
export class PaymentRedirectComponent implements OnInit {
  paymentUrl: string = '';
  policyId: string = '';

  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.paymentUrl = params['paymentUrl'] || '';
      this.policyId = params['id'] || '';

      if (!this.paymentUrl) {
        Sentry.captureMessage(
          'Payment redirect page loaded without payment URL',
        );
        console.error('No payment URL provided in redirect');
      }
    });
  }

  redirectToPayment(): void {
    if (isPlatformBrowser(this.platformId) && this.paymentUrl) {
      // Try opening in new window first
      const paymentWindow = window.open(this.paymentUrl, '_blank');

      // If that fails, redirect in the same window
      if (
        !paymentWindow ||
        paymentWindow.closed ||
        typeof paymentWindow.closed === 'undefined'
      ) {
        window.location.href = this.paymentUrl;
      }
    }
  }

  redirectInSameWindow(): void {
    if (isPlatformBrowser(this.platformId) && this.paymentUrl) {
      window.location.href = this.paymentUrl;
    }
  }
}
